import React from 'react'
import { Create, useForm } from '@refinedev/antd'
import { Form, Input, Switch } from 'antd'

interface FeatureFlag {
  key: string
  enabled: boolean
  description: string | null
}

export function FeatureFlagCreate() {
  const { formProps, saveButtonProps } = useForm<FeatureFlag>({
    resource: 'feature_flags',
    meta: { idColumnName: 'key' },
  })

  return (
    <Create saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical" initialValues={{ enabled: false }}>
        <Form.Item
          label="Key"
          name="key"
          rules={[{ required: true, message: 'Key is required' }]}
        >
          <Input placeholder="e.g. giving_enabled" />
        </Form.Item>
        <Form.Item label="Description" name="description">
          <Input.TextArea rows={2} placeholder="What this flag controls" />
        </Form.Item>
        <Form.Item label="Enabled" name="enabled" valuePropName="checked">
          <Switch />
        </Form.Item>
      </Form>
    </Create>
  )
}
